export enum PlaceIconsType {
  airport = 'local_airport',
  attractions = 'location_on',
  hotel = 'hotel',
  distrcict = 'location_on',
  city = 'location_on',
  trainStation = 'directions_subway',
  transitStation = 'directions_railway',
  subwayStation = 'directions_subway',
  busStation = 'directions_bus',
  organization = 'location_on',
  poi = 'flag',
}
